import { getMsgDeskRuntime } from '@/msgdeskRuntime'

export type LegacyContractName =
  | 'page.root'
  | 'page.table'
  | 'page.header'
  | 'page.headerCell'
  | 'page.accentCell'
  | 'page.workspaceCell'
  | 'page.rightRail'
  | 'page.footer'
  | 'page.backImage'
  | 'page.advert'
  | 'workspace.main'
  | 'workspace.editor'
  | 'workspace.attachments'
  | 'workspace.favs'
  | 'workspace.trash'
  | 'workspace.drafts'
  | 'main.root'
  | 'main.header'
  | 'main.subjectRegion'
  | 'main.subjectLine'
  | 'main.datetime'
  | 'main.quad'
  | 'main.body'
  | 'main.iframe'
  | 'main.editMount'
  | 'main.avatarFrame'
  | 'main.avatarImage'
  | 'main.nameKeySign'
  | 'main.authorFrame'
  | 'main.emailRegion'
  | 'main.siteView'
  | 'main.emailText'
  | 'main.emailLink'
  | 'main.subjectText'
  | 'main.lineClear'
  | 'main.foldButton'
  | 'editor.root'
  | 'editor.close'
  | 'editor.form'
  | 'editor.head'
  | 'editor.headShort'
  | 'editor.head.nameKey'
  | 'editor.head.subject'
  | 'editor.head.recipients'
  | 'editor.smartName.root'
  | 'editor.smartName.sign'
  | 'editor.smartName.inputBox'
  | 'editor.smartName.actions'
  | 'editor.extName.root'
  | 'editor.extName.textarea'
  | 'editor.extName.hiddenMirror'
  | 'editor.extName.check'
  | 'editor.extName.subKeyText'
  | 'editor.extName.codeKey'
  | 'editor.extName.codeKeyInfo'
  | 'editor.subject.inputBox'
  | 'editor.subject.button'
  | 'editor.subject.span'
  | 'editor.recipients.root'
  | 'editor.recipients.list'
  | 'editor.recipients.button'
  | 'editor.recipients.span'
  | 'editor.recipients.checkButton'
  | 'editor.recipients.emailCheck'
  | 'editor.recipients.msgCheck'
  | 'editor.body'
  | 'editor.body.textarea'
  | 'editor.settings'
  | 'editor.settings.main'
  | 'editor.settings.advanced'
  | 'editor.settings.email'
  | 'editor.settings.counts'
  | 'editor.settings.more'
  | 'editor.settings.protect'
  | 'editor.settings.avatar'
  | 'editor.settings.avatarForm'
  | 'editor.settings.pageColor'
  | 'editor.settings.pageOptions'
  | 'editor.nameKey.defaultAuto'
  | 'editor.nameKey.subKey'
  | 'editor.nameKey.textarea'
  | 'editor.nameKey.mirror'
  | 'editor.nameKey.check'
  | 'editor.nameKey.emailInfo'
  | 'editor.nameKey.showChangeCode'
  | 'editor.nameKey.changeCode'
  | 'editor.nameKey.checkCode'
  | 'editor.nameKey.closeChangeCode'
  | 'editor.nameKey.codeKeyInfo'
  | 'editor.time.start'
  | 'editor.time.stop'
  | 'editor.actions'
  | 'editor.actions.moreSectionButton'
  | 'editor.action.save'
  | 'editor.action.draft'
  | 'editor.action.attachForm'
  | 'editor.action.moreSettings'
  | 'editor.action.delete'
  | 'editor.action.clear'
  | 'editor.action.saveAndGo'
  | 'editor.action.restore'
  | 'editor.attachments.gallery'
  | 'editor.body.richFormatButton'
  | 'editor.body.isDirty'
  | 'editor.body.richExt'
  | 'editor.body.dskEls'
  | 'editor.quickReply.root'
  | 'editor.quickReply.form'
  | 'editor.quickReply.input'
  | 'editor.quickReply.sendEmail'
  | 'editor.quickReply.link'
  | 'editor.pin.root'
  | 'editor.pin.input'
  | 'editor.loading'
  | 'sidebar.root'
  | 'sidebar.wait'
  | 'sidebar.editGroup.button'
  | 'sidebar.editGroup.body'
  | 'sidebar.moreSettings'
  | 'subs.toolbar'
  | 'subs.toolbar.hide'
  | 'subs.toolbar.groupsInfo'
  | 'subs.toolbar.groupsInfo2'
  | 'subs.toolbar.message'
  | 'subs.panelTools'
  | 'subs.menuToggle.answers'
  | 'subs.menuToggle.submsges'
  | 'subs.menuToggle.count'
  | 'subs.togglePhoto'
  | 'subs.menuMode.panel'
  | 'subs.menuMode.answersList'
  | 'subs.menuMode.submsgesList'
  | 'subs.favs.answersFront'
  | 'subs.favs.submsgesFront'
  | 'subs.trash.answersFront'
  | 'subs.trash.submsgesFront'
  | 'subs.drafts.answersFront'
  | 'subs.drafts.submsgesFront'
  | 'subs.answers.front'
  | 'subs.answers.rootList'
  | 'subs.submsges.front'
  | 'subs.submsges.rootList'
  | 'subs.paging.answers'
  | 'subs.paging.submsges'
  | 'subs.checked.answers'
  | 'subs.checked.submsges'
  | 'legacyData.msges'
  | 'legacyData.msgesJson'
  | 'legacyData.init';

export interface LegacySelectorAlias {
  contract: LegacyContractName;
  legacyId?: string;
  legacyClass?: string;
  legacyClasses?: string[];
  description: string;
}

interface LegacyCompoundSelectorAlias {
  parent: LegacyContractName;
  parentLegacyTokens: string[];
  childLegacyClass: string;
  child: LegacyContractName;
  description: string;
}

export type LegacyCssTokenName =
  | 'shared.noSelect'
  | 'icon.clipart'
  | 'icon.submsgEdit'
  | 'icon.options'
  | 'icon.plus'
  | 'icon.refreshSubs'
  | 'icon.flagChecked'
  | 'sidebar.home'
  | 'sidebar.buttonsTopContainer'
  | 'sidebar.answersButtons'
  | 'sidebar.buttonsTop'
  | 'sidebar.topPlace'
  | 'sidebar.qrTop'
  | 'sidebar.qrPlace'
  | 'sidebar.thisMessage'
  | 'sidebar.menuSelected'
  | 'sidebar.menuItemDiv'
  | 'sidebar.qrMainPlace'
  | 'sidebar.editItem'
  | 'sidebar.editGroup'
  | 'sidebar.menuButton'
  | 'sidebar.newSubItem'
  | 'sidebar.newSubButton'
  | 'sidebar.newSubLabelNew'
  | 'sidebar.newSubLabel'
  | 'sidebar.newSubIcon'
  | 'sidebar.helpItem'
  | 'sidebar.notEdit'
  | 'sidebar.waitPopup'
  | 'sidebar.menuDiv'
  | 'sidebar.leftBlock'
  | 'sidebar.mainMenu'
  | 'sidebar.oneLine'
  | 'sidebar.menuToggle'
  | 'sidebar.nav.answersStd'
  | 'sidebar.nav.answers'
  | 'sidebar.nav.messages'
  | 'sidebar.nav.attachments'
  | 'sidebar.nav.bookmarks'
  | 'sidebar.nav.drafts'
  | 'sidebar.nav.trash'
  | 'subs.checkedInfo'
  | 'subs.currentCheckedCounter'
  | 'subs.allCheckedCounter'
  | 'subs.checkedAction'
  | 'subs.paging.root'
  | 'subs.paging.page'
  | 'subs.paging.current'
  | 'subs.paging.disabled'
  | 'subs.fold.label'
  | 'subs.fold.count'
  | 'subs.more'
  | 'quickReply.root'
  | 'quickReply.form'
  | 'quickReply.editForm'
  | 'quickReply.textarea'
  | 'quickReply.emailLabel'
  | 'quickReply.checkbox'
  | 'quickReply.emailLink'
  | 'quickReply.saveButton'
  | 'quickReply.shadowRight'
  | 'quickReply.shadowBottom'
  | 'quickReply.opacity'
  | 'editor.state.active'
  | 'editor.rootClass'
  | 'editor.formHead'
  | 'editor.settings.tools'
  | 'editor.settings.panel'
  | 'editor.settings.tabs'
  | 'editor.settings.tab1'
  | 'editor.settings.tab2'
  | 'editor.settings.tab3'
  | 'editor.settings.tab4'
  | 'editor.settings.tab5'
  | 'editor.settings.tab6'
  | 'editor.settings.avatarPanel'
  | 'editor.input.checkbox'
  | 'editor.input.combo'
  | 'editor.input.text'
  | 'editor.input.protect'
  | 'editor.attachment.form'
  | 'editor.attachment.fileToAttach'
  | 'editor.attachment.file'
  | 'editor.attachment.avatarPreview'
  | 'editor.smartName.rootClass'
  | 'editor.smartName.signClass'
  | 'editor.smartName.inputClass'
  | 'editor.smartName.hidden'
  | 'editor.smartName.actionsClass'
  | 'editor.smartName.quickMenu'
  | 'editor.smartName.quickItems'
  | 'editor.extName.rootClass'
  | 'editor.extName.quickRoot'
  | 'editor.extName.label'
  | 'editor.extName.button'
  | 'editor.extName.textareaWrap'
  | 'editor.extName.textarea'
  | 'editor.extName.mirror'
  | 'editor.extName.checkWrap'
  | 'editor.extName.checkButton'
  | 'editor.extName.subKey'
  | 'editor.extName.emailInfo'
  | 'editor.extName.emailInfoEdit'
  | 'editor.extName.errors'
  | 'editor.extName.codeKey'
  | 'editor.extName.codeInput'
  | 'editor.extName.codeInfo'
  | 'editor.recipients.rootClass'
  | 'editor.recipients.label'
  | 'editor.recipients.list'
  | 'editor.recipients.item'
  | 'editor.recipients.text'
  | 'editor.recipients.remove'
  | 'editor.recipients.inputWrap'
  | 'editor.attachments.bottom'
  | 'editor.attachments.fieldset'
  | 'editor.attachments.gallery'
  | 'editor.attachments.galleryAlt'
  | 'editor.attachments.fileLabel'
  | 'editor.attachments.imageHolder'
  | 'editor.attachments.imageHolder2'
  | 'editor.attachments.transparent6'
  | 'editor.attachments.imageTop'
  | 'editor.attachments.removeFile'
  | 'editor.attachments.removePercent'
  | 'editor.attachments.lineClear'
  | 'editor.attachments.fileName'
  | 'editor.attachments.upload'
  | 'editor.actions.rootClass'
  | 'editor.actions.button'
  | 'editor.actions.buttonPrimary'
  | 'editor.actions.buttonDraft'
  | 'editor.actions.buttonAttach'
  | 'editor.actions.buttonSettings'
  | 'editor.actions.buttonLabel'
  | 'editor.actions.attachIcon'
  | 'editor.body.toolButton'
  | 'editor.body.richToolbar'
  | 'editor.body.dskToolbar'
  | 'editor.body.textWrap'
  | 'editor.body.textInner'
  | 'editor.head.tabsWrap'
  | 'editor.head.active'
  | 'editor.subject.rootClass'
  | 'sub.row.checked'
  | 'sub.row.unchecked'
  | 'sub.row.answer'
  | 'sub.row.answerCompact'
  | 'sub.row.answerStd'
  | 'sub.row.hidden'
  | 'sub.row.foreign'
  | 'sub.icon.flag'
  | 'sub.icon.fav'
  | 'sub.icon.favGrey'
  | 'sub.icon.qr'
  | 'sub.icon.qrOn'
  | 'sub.title.link'
  | 'sub.title.subject'
  | 'sub.time.wrap'
  | 'sub.time.text'
  | 'sub.text.compact'
  | 'sub.text.body'
  | 'sub.meta'
  | 'sub.list.answers'
  | 'sub.list.submsges'
  | 'sub.legacy.card'
  | 'sub.legacy.cardTitle'
  | 'sub.legacy.commentsBlock'
  | 'sub.legacy.avatar'
  | 'sub.legacy.textBlock'
  | 'sub.legacy.compact'
  | 'sub.legacy.iconBlock'
  | 'sub.legacy.compactHeader'
  | 'sub.legacy.email';

export const LEGACY_CSS_TOKENS: Record<LegacyCssTokenName, string> = {
  'shared.noSelect': 'mcss-no_select-cssm',
  'icon.clipart': 'mcss-ic_clprt_lists-cssm',
  'icon.submsgEdit': 'mcss-ic_submsgedit-cssm',
  'icon.options': 'mcss-ic_options-cssm',
  'icon.plus': 'mcss-plus_btn-cssm',
  'icon.refreshSubs': 'mcss-ic_refresh_subs-cssm',
  'icon.flagChecked': 'mcss-ic_flag_small_blue-cssm',
  'sidebar.home': 'mcss-li_home-cssm',
  'sidebar.buttonsTopContainer': 'mcss-msg_buttons_top_cont-cssm',
  'sidebar.answersButtons': 'mcss-answers_buttons-cssm',
  'sidebar.buttonsTop': 'mcss-msg_buttons_top-cssm',
  'sidebar.topPlace': 'mcss-top_place-cssm',
  'sidebar.qrTop': 'mcss-qr_top-cssm',
  'sidebar.qrPlace': 'mcss-qr_place-cssm',
  'sidebar.thisMessage': 'mcss-li_this_msg-cssm',
  'sidebar.menuSelected': 'mcss-menu_selected-cssm',
  'sidebar.menuItemDiv': 'mcss-menu_li_div-cssm',
  'sidebar.qrMainPlace': 'mcss-qr_place_main-cssm',
  'sidebar.editItem': 'mcss-li_edit-cssm',
  'sidebar.editGroup': 'mcss-edit_group-cssm',
  'sidebar.menuButton': 'mcss-msg_buttons-cssm',
  'sidebar.newSubItem': 'mcss-li_new_sub-cssm',
  'sidebar.newSubButton': 'mcss-menu_li_new_sub_button-cssm',
  'sidebar.newSubLabelNew': 'mcss-menu_li_new_sub_button_label_new-cssm',
  'sidebar.newSubLabel': 'mcss-menu_li_new_sub_button_label-cssm',
  'sidebar.newSubIcon': 'mcss-menu_li_new_sub_button_icon-cssm',
  'sidebar.helpItem': 'mcss-li_help-cssm',
  'sidebar.notEdit': 'mcss-li_not_edit-cssm',
  'sidebar.waitPopup': 'mcss-wait_pop_up-cssm',
  'sidebar.menuDiv': 'mcss-menu_div-cssm',
  'sidebar.leftBlock': 'mcss-leftblock-cssm',
  'sidebar.mainMenu': 'mcss-main_menu-cssm',
  'sidebar.oneLine': 'mcss-one_line-cssm',
  'sidebar.menuToggle': 'mcss-menu_toggle-cssm',
  'sidebar.nav.answersStd': 'mcss-li_answers_std-cssm',
  'sidebar.nav.answers': 'mcss-li_answers-cssm',
  'sidebar.nav.messages': 'mcss-li_submsges-cssm',
  'sidebar.nav.attachments': 'mcss-li_attaches-cssm',
  'sidebar.nav.bookmarks': 'mcss-li_favs-cssm',
  'sidebar.nav.drafts': 'mcss-li_drafts-cssm',
  'sidebar.nav.trash': 'mcss-li_trash-cssm',
  'subs.checkedInfo': 'mcss-checkeds_info_div-cssm',
  'subs.currentCheckedCounter': 'mcss-current_checkeds_counter-cssm',
  'subs.allCheckedCounter': 'mcss-all_checkeds_counter-cssm',
  'subs.checkedAction': 'mcss-del_checked_span-cssm',
  'subs.paging.root': 'mcss-paging_el-cssm',
  'subs.paging.page': 'mcss-page_el-cssm',
  'subs.paging.current': 'mcss-current_page-cssm',
  'subs.paging.disabled': 'mcss-str_disable-cssm',
  'subs.fold.label': 'mcss-subs_btn_1-cssm',
  'subs.fold.count': 'mcss-subs_btn_2-cssm',
  'subs.more': 'mcss-msg_subs_info-cssm',
  'quickReply.root': 'mcss-qr_div-cssm',
  'quickReply.form': 'mcss-qr_form-cssm',
  'quickReply.editForm': 'mcss-editform_quickreply-cssm',
  'quickReply.textarea': 'mcss-answertextarea-cssm',
  'quickReply.emailLabel': 'mcss-qr_email-cssm',
  'quickReply.checkbox': 'mcss-newmsg_checkbox-cssm',
  'quickReply.emailLink': 'mcss-email_link-cssm',
  'quickReply.saveButton': 'mcss-save_qr_btn-cssm',
  'quickReply.shadowRight': 'mcss-qr_shadow_right-cssm',
  'quickReply.shadowBottom': 'mcss-qr_shadow_bottom-cssm',
  'quickReply.opacity': 'mcss-qr_opacity-cssm',
  'editor.state.active': 'mcss-active-cssm',
  'editor.rootClass': 'mcss-newmsg-cssm',
  'editor.formHead': 'mcss-tr_head-cssm',
  'editor.settings.tools': 'mcss-fieldsets_tools-cssm',
  'editor.settings.panel': 'mcss-fieldsets-cssm',
  'editor.settings.tabs': 'mcss-tabs-cssm',
  'editor.settings.tab1': 'mcss-tab-cssm_1',
  'editor.settings.tab2': 'mcss-tab-cssm_2',
  'editor.settings.tab3': 'mcss-tab-cssm_3',
  'editor.settings.tab4': 'mcss-tab-cssm_4',
  'editor.settings.tab5': 'mcss-tab-cssm_5',
  'editor.settings.tab6': 'mcss-tab-cssm_6',
  'editor.settings.avatarPanel': 'mcss-fieldset_avatar-cssm',
  'editor.input.checkbox': 'mcss-newmsg_checkbox-cssm',
  'editor.input.combo': 'mcss-label_check_combo_int-cssm',
  'editor.input.text': 'mcss-newmsg_inputs-cssm',
  'editor.input.protect': 'mcss-protect_input-cssm',
  'editor.attachment.form': 'mcss-att_form-cssm',
  'editor.attachment.fileToAttach': 'mcss-file_to_attach-cssm',
  'editor.attachment.file': 'mcss-file-cssm',
  'editor.attachment.avatarPreview': 'mcss-avatar_div-cssm',
  'editor.smartName.rootClass': 'mcss-head_smart-cssm',
  'editor.smartName.signClass': 'mcss-sign_name_key-cssm',
  'editor.smartName.inputClass': 'mcss-smart_name_key-cssm',
  'editor.smartName.hidden': 'mcss-hidden_name_key-cssm',
  'editor.smartName.actionsClass': 'mcss-ext_name_key-cssm',
  'editor.smartName.quickMenu': 'mcss-ext_quick_menu-cssm',
  'editor.smartName.quickItems': 'mcss-ext_quick_menu_items-cssm',
  'editor.extName.rootClass': 'mcss-head_ext-cssm',
  'editor.extName.quickRoot': 'mcss-quick_name_key-cssm',
  'editor.extName.label': 'mcss-label_btn-cssm',
  'editor.extName.button': 'mcss-butt2-cssm',
  'editor.extName.textareaWrap': 'mcss-namekeydiv-cssm',
  'editor.extName.textarea': 'mcss-namekey-cssm',
  'editor.extName.mirror': 'mcss-namekey_hidden-cssm',
  'editor.extName.checkWrap': 'mcss-checknamekeydiv-cssm',
  'editor.extName.checkButton': 'mcss-checknamekey-cssm',
  'editor.extName.subKey': 'mcss-sub_key-cssm',
  'editor.extName.emailInfo': 'mcss-supposecodekey-cssm',
  'editor.extName.emailInfoEdit': 'mcss-supposecodekey2-cssm',
  'editor.extName.errors': 'mcss-namekey_errors-cssm',
  'editor.extName.codeKey': 'mcss-codekey_div-cssm',
  'editor.extName.codeInput': 'mcss-input_codekey-cssm',
  'editor.extName.codeInfo': 'mcss-code_key_info-cssm',
  'editor.recipients.rootClass': 'mcss-new_email_div-cssm',
  'editor.recipients.label': 'mcss-new_to_msg_label-cssm',
  'editor.recipients.list': 'mcss-new_to_msg_list-cssm',
  'editor.recipients.item': 'mcss-new_to_msg-cssm',
  'editor.recipients.text': 'mcss-new_to_msg_txt-cssm',
  'editor.recipients.remove': 'mcss-new_to_msg_x-cssm',
  'editor.recipients.inputWrap': 'mcss-new_to_msg_input-cssm',
  'editor.attachments.bottom': 'mcss-new_bottom_section2-cssm',
  'editor.attachments.fieldset': 'mcss-fieldset_attach-cssm',
  'editor.attachments.gallery': 'mcss-attaches_gallery-cssm',
  'editor.attachments.galleryAlt': 'mcss-att_glr-cssm',
  'editor.attachments.fileLabel': 'mcss-file_label-cssm',
  'editor.attachments.imageHolder': 'mcss-img_holder-cssm',
  'editor.attachments.imageHolder2': 'mcss-img_holder_2-cssm',
  'editor.attachments.transparent6': 'mcss-transp_6-cssm',
  'editor.attachments.imageTop': 'mcss-img_top-cssm',
  'editor.attachments.removeFile': 'mcss-rm_file-cssm',
  'editor.attachments.removePercent': 'mcss-rm_file_2-cssm',
  'editor.attachments.lineClear': 'mcss-line_clear-cssm',
  'editor.attachments.fileName': 'mcss-file_name-cssm',
  'editor.attachments.upload': 'mcss-newmsg_attach_upload-cssm',
  'editor.actions.rootClass': 'mcss-newmsg_submit-cssm',
  'editor.actions.button': 'mcss-newmsg_submit_buttons-cssm',
  'editor.actions.buttonPrimary': 'mcss-newmsg_submit_buttons_new-cssm',
  'editor.actions.buttonDraft': 'mcss-newmsg_submit_buttons_draft-cssm',
  'editor.actions.buttonAttach': 'mcss-newmsg_submit_buttons_attach-cssm',
  'editor.actions.buttonSettings': 'mcss-newmsg_submit_buttons_settings-cssm',
  'editor.actions.buttonLabel': 'mcss-newmsg_submit_buttons_settings_label-cssm',
  'editor.actions.attachIcon': 'mcss-ic_attach-cssm',
  'editor.body.toolButton': 'mcss-new_msg_btn-cssm',
  'editor.body.richToolbar': 'mcss-rich_edit_toolbar-cssm',
  'editor.body.dskToolbar': 'mcss-dsk_els_toolbar-cssm',
  'editor.body.textWrap': 'mcss-msgtextdiv-cssm',
  'editor.body.textInner': 'mcss-msg_text-cssm',
  'editor.head.tabsWrap': 'mcss-tr_head_td-cssm',
  'editor.head.active': 'mcss-head_active-cssm',
  'editor.subject.rootClass': 'mcss-subject_div-cssm',
  'sub.row.checked': 'mcss-onliststyle-cssm',
  'sub.row.unchecked': 'mcss-offliststyle-cssm',
  'sub.row.answer': 'mcss-li_answers-cssm',
  'sub.row.answerCompact': 'mcss-li_answers_c-cssm',
  'sub.row.answerStd': 'mcss-li_answers_std-cssm',
  'sub.row.hidden': 'mcss-display_none-cssm',
  'sub.row.foreign': 'mcss-li_foreign-cssm',
  'sub.icon.flag': 'mcss-ic_flag_small-cssm',
  'sub.icon.fav': 'mcss-ic_fav-cssm',
  'sub.icon.favGrey': 'mcss-ic_fav_grey-cssm',
  'sub.icon.qr': 'mcss-ic_qr-cssm',
  'sub.icon.qrOn': 'mcss-ic_qr_on-cssm',
  'sub.title.link': 'mcss-sub_link-cssm',
  'sub.title.subject': 'mcss-msg_headline_subject_2-cssm',
  'sub.time.wrap': 'mcss-list_time_div_c-cssm',
  'sub.time.text': 'mcss-list_compact_time-cssm',
  'sub.text.compact': 'mcss-list_txt_compact-cssm',
  'sub.text.body': 'mcss-sub_text-cssm',
  'sub.meta': 'mcss-list_subs_info-cssm',
  'sub.list.answers': 'mcss-list_answers_ul-cssm',
  'sub.list.submsges': 'mcss-list_submsges_ul-cssm',
  'sub.legacy.card': 'mcss-li_gallery_div-cssm',
  'sub.legacy.cardTitle': 'mcss-title_glr_1-cssm',
  'sub.legacy.commentsBlock': 'mcss-comments_text_block-cssm',
  'sub.legacy.avatar': 'mcss-avatart-cssm',
  'sub.legacy.textBlock': 'mcss-msgtxtblock_compact-cssm',
  'sub.legacy.compact': 'mcss-compact_div-cssm',
  'sub.legacy.iconBlock': 'mmmcss-msg_icon_div-cssm',
  'sub.legacy.compactHeader': 'mcss-list_compact_head_txt-cssm',
  'sub.legacy.email': 'mcss-email_div-cssm',
};

export type LegacyReadPredicate = ':checked' | ':checkbox' | ':visible' | ':hidden';

export const LEGACY_READ_PREDICATES: Record<LegacyReadPredicate, { semantic: string }> = {
  ':checked': { semantic: 'checked' },
  ':checkbox': { semantic: 'checkboxInput' },
  ':visible': { semantic: 'visible' },
  ':hidden': { semantic: 'hidden' },
};

export const LEGACY_STATE_CLASSES = {
  'mcss-display_none-cssm': { semantic: 'visible', addValue: false, subFlag: 'isVisible' },
  'mcss-ic_fav-cssm': { semantic: 'favorite', addValue: true, subFlag: 'isFav' },
  'mcss-ic_fav_grey-cssm': { semantic: 'favorite', addValue: false, subFlag: 'isFav' },
  'mcss-ic_off-cssm': { semantic: 'favoriteIconDisabled', addValue: true, subFlag: 'isFavIconOff' },
  'mcss-ic_qr_on-cssm': { semantic: 'quickReplyOpen', addValue: true, subFlag: 'isQrOn' },
  'mcss-ic_ht_red-cssm': { semantic: 'hoverHighlighted', addValue: true, subFlag: 'isHoverHighlighted' },
  'mcss-ic_flag_small_blue-cssm': { semantic: 'checked', addValue: true, subFlag: 'isFlagBlue' },
  'mcss-ic_flag_small-cssm': { semantic: 'checked', addValue: false, subFlag: 'isFlagBlue' },
  'mcss-onliststyle-cssm': { semantic: 'checked', addValue: true, subFlag: 'isFlagBlue' },
  'mcss-offliststyle-cssm': { semantic: 'checked', addValue: false, subFlag: 'isFlagBlue' },
  'mcss-active-cssm': { semantic: 'active', addValue: true },
  active: { semantic: 'active', addValue: true },
  'mcss-selected-cssm': { semantic: 'selected', addValue: true },
  'mcss-current_page-cssm': { semantic: 'currentPage', addValue: true },
  'mcss-str_disable-cssm': { semantic: 'disabled', addValue: true },
  'mcss-head_active-cssm': { semantic: 'activeEditorHead', addValue: true },
  'mcss-name_key_check_disable-cssm': { semantic: 'nameKeyCheckDisabled', addValue: true },
  'mcss-name_key_wrong-cssm': { semantic: 'nameKeyInvalid', addValue: true },
  'mcss-name_key_ok-cssm': { semantic: 'nameKeyOk', addValue: true },
  'mcss-name_key_busy-cssm': { semantic: 'nameKeyBusy', addValue: true },
  'mcss-active_ok-cssm': { semantic: 'smartNameConfirmed', addValue: true },
  'mcss-info_el_error-cssm': { semantic: 'inlineError', addValue: true },
  'mcss-ic_toggle_on-cssm': { semantic: 'toggleOn', addValue: true },
  'mcss-ic_toggle_off-cssm': { semantic: 'toggleOff', addValue: false },
  'mcss-ic_toggle_menu_on-cssm': { semantic: 'menuToggleOn', addValue: true },
  'mcss-ic_toggle_menu_off-cssm': { semantic: 'menuToggleOff', addValue: false },
  'mcss-save_qr_over-cssm': { semantic: 'hover', addValue: true },
  'mcss-menu_over-cssm': { semantic: 'hover', addValue: true },
  'mcss-sub_answ_div_hide-cssm': { semantic: 'answersFolded', addValue: true },
  'mcss-sub_answ_div_hide_2-cssm': { semantic: 'messagesFolded', addValue: true },
  'mcss-msg_newmsg_rich_div-cssm': { semantic: 'richEditorMode', addValue: true },
  'mcss-menu_selected-cssm': { semantic: 'selectedMenu', addValue: true },
  'mcss-atts_is_open-cssm': { semantic: 'attachmentsOpen', addValue: true },
  drafting_mode: { semantic: 'draftingMode', addValue: true },
} as const;

export const LEGACY_SUB_CLASS_TO_FLAG = Object.fromEntries(
  Object.entries(LEGACY_STATE_CLASSES)
    .filter((entry): entry is [string, typeof LEGACY_STATE_CLASSES[keyof typeof LEGACY_STATE_CLASSES] & { subFlag: string }] => 'subFlag' in entry[1])
    .map(([className, state]) => [className, { flag: state.subFlag, addValue: state.addValue }]),
);

export function isLegacyStateClass(className: string): boolean {
  return Object.prototype.hasOwnProperty.call(LEGACY_STATE_CLASSES, className);
}

export const LEGACY_SELECTOR_ALIASES: readonly LegacySelectorAlias[] = [
  { contract: 'page.root', legacyClass: 'mcss-page_div-cssm', description: 'Outer page root.' },
  { contract: 'page.table', legacyId: 'mcss-maintable-cssm', legacyClass: 'mcss-top_mn-cssm', description: 'Main legacy table shell.' },
  { contract: 'page.header', legacyClass: 'mcss-tr_header-cssm', description: 'Header table row.' },
  { contract: 'page.headerCell', legacyClass: 'mcss-td_header-cssm', description: 'Header table cell.' },
  { contract: 'page.accentCell', description: 'Blue accent table cell.' },
  { contract: 'page.workspaceCell', legacyClass: 'mcss-msg_td-cssm', description: 'Main workspace table cell.' },
  { contract: 'page.rightRail', legacyClass: 'mcss-leftblock_td-cssm', description: 'Right rail table cell.' },
  { contract: 'page.footer', legacyClass: 'mcss-footer_td-cssm', description: 'Footer table cell.' },
  { contract: 'page.backImage', legacyId: 'mcss-backimg-cssm', description: 'Brand image in the right rail.' },
  { contract: 'page.advert', legacyId: 'mcss-adver-cssm', description: 'Advertisement block in the right rail.' },

  { contract: 'workspace.main', legacyClass: 'mcss-msg_main_div-cssm', legacyClasses: ['mcss-rterter-cssm'], description: 'Read-mode main message workspace.' },
  { contract: 'workspace.editor', legacyClass: 'mcss-msg_newmsg_div-cssm', description: 'New/update editor workspace.' },
  { contract: 'workspace.attachments', legacyClass: 'mcss-msg_attachments_div-cssm', description: 'Attachments workspace.' },
  { contract: 'workspace.favs', legacyClass: 'mcss-msg_favs_div-cssm', description: 'Bookmarks workspace.' },
  { contract: 'workspace.trash', legacyClass: 'mcss-msg_trash_div-cssm', description: 'Basket workspace.' },
  { contract: 'workspace.drafts', legacyClass: 'mcss-msg_drafts_div-cssm', description: 'Drafts workspace.' },

  { contract: 'main.root', legacyId: 'mcss-MSGBODY-cssm', legacyClass: 'mcss-msg_body-cssm', description: 'Main message read-view root.' },
  { contract: 'main.header', legacyId: 'mcss-MSGBODYMAINHEAD-cssm', legacyClass: 'mcss-main_title-cssm', description: 'Main message author/header region.' },
  { contract: 'main.subjectRegion', legacyId: 'mcss-MSGBODYSUBJECTHEAD-cssm', legacyClass: 'mcss-msg_subject-cssm', description: 'Main message subject/date region.' },
  { contract: 'main.subjectLine', legacyClass: 'mcss-mainmsg_headline-cssm', description: 'Subject line wrapper.' },
  { contract: 'main.datetime', legacyClass: 'mcss-mainmsg_headline_time-cssm', description: 'Main message datetime text.' },
  { contract: 'main.quad', legacyId: 'mcss-MSGQUAD-cssm', legacyClass: 'mcss-msg_quad-cssm', description: 'Main message subject/body container.' },
  { contract: 'main.body', legacyClass: 'mcss-mainmsgbody-cssm', description: 'Main message body wrapper.' },
  { contract: 'main.iframe', legacyId: 'mcss-mainmsg_iframe-cssm', description: 'Main message rich body content holder.' },
  { contract: 'main.editMount', legacyId: 'mcss-txtblock0-cssm', legacyClass: 'mcss-list_editform_place-cssm', description: 'Inline edit form mount point.' },
  { contract: 'main.avatarFrame', legacyClass: 'mcss-avatart1-cssm', description: 'Main message avatar frame.' },
  { contract: 'main.avatarImage', legacyClasses: ['mcss-hc_avatar-cssm', 'mcss-e_hc_avatar-cssm'], description: 'Main message avatar image.' },
  { contract: 'main.nameKeySign', legacyClasses: ['mcss-mainmsg_namekey-cssm', 'mcss-name_key_sign-cssm'], description: 'Main message @ name-key sign.' },
  { contract: 'main.authorFrame', legacyClasses: ['mcss-mainmsg_namekey-cssm', 'mcss-msg_name_key-cssm'], description: 'Main message author/name-key text.' },
  { contract: 'main.emailRegion', legacyClass: 'mcss-main_email_div-cssm', description: 'Main message email details region.' },
  { contract: 'main.siteView', legacyClass: 'mcss-mainmsg_siteview-cssm', description: 'Main message site-view toggle text.' },
  { contract: 'main.emailText', legacyClasses: ['mcss-mainmsg_email-cssm', 'mcss-no_select-cssm'], description: 'Main message email label text.' },
  { contract: 'main.emailLink', legacyClass: 'mcss-mainmsg_email-cssm', description: 'Main message email link.' },
  { contract: 'main.subjectText', legacyClass: 'mcss-mainmsg_headline_subject-cssm', description: 'Main message subject text.' },
  { contract: 'main.lineClear', legacyClass: 'mcss-line_clear-cssm', description: 'Main message clear line helper.' },
  { contract: 'main.foldButton', legacyClasses: ['mcss-iframe_fold-cssm', 'mcss-no_select-cssm'], description: 'Main message fold button.' },

  { contract: 'editor.root', legacyClass: 'mcss-newmsg-cssm', description: 'New/update editor root.' },
  { contract: 'editor.close', legacyId: 'mcss-fgffjk-cssm', description: 'Editor top-section close/toggle target.' },
  { contract: 'editor.form', legacyId: 'mcss-newsubmsg-cssm', description: 'New/update form element.' },
  { contract: 'editor.head', legacyId: 'mcss-tr_head-cssm', description: 'Editor head fields row.' },
  { contract: 'editor.headShort', legacyId: 'mcss-tr_head_short-cssm', description: 'Collapsed editor head row.' },
  { contract: 'editor.head.nameKey', legacyId: 'mcss-head_name_key-cssm', description: 'Name key head field.' },
  { contract: 'editor.head.subject', legacyId: 'mcss-head_subject-cssm', description: 'Subject head field.' },
  { contract: 'editor.head.recipients', legacyId: 'mcss-head_recipients-cssm', description: 'Recipients head field.' },
  { contract: 'editor.smartName.root', legacyId: 'mcss-head_smart-cssm', description: 'Smart name-key row.' },
  { contract: 'editor.smartName.sign', legacyClass: 'mcss-sign_name_key-cssm', description: 'Smart name-key sign/status.' },
  { contract: 'editor.smartName.inputBox', legacyClass: 'mcss-smart_name_key-cssm', description: 'Smart name-key input wrapper.' },
  { contract: 'editor.smartName.actions', legacyClass: 'mcss-ext_name_key-cssm', description: 'Smart name-key check/quick actions.' },
  { contract: 'editor.extName.root', legacyId: 'mcss-new_msg_head-cssm', description: 'Extended name-key section.' },
  { contract: 'editor.extName.subKeyText', legacyId: 'mcss-sub_key_txt-cssm', description: 'Sub-key text indicator.' },
  // The other editor.extName.* aliases (nk21/nk22/check_name_key/
  // change_code_key/code_key_info) were superseded by the editor.nameKey.*
  // entries below. Keeping both made the selector REWRITER (first alias wins)
  // disagree with the byLegacyId lookup (last wins): "#mcss-change_code_key-cssm"
  // rewrote to a contract no element renders, so legacy toggle_code_key showed
  // nothing. A legacyId must map to exactly ONE alias entry.
  { contract: 'editor.subject.inputBox', legacyClass: 'mcss-subject_div-cssm', description: 'Subject input wrapper.' },
  { contract: 'editor.subject.button', legacyId: 'mcss-subject_button-cssm', description: 'Legacy subject helper button span.' },
  { contract: 'editor.subject.span', legacyId: 'mcss-subject_span-cssm', description: 'Legacy subject helper text span.' },
  { contract: 'editor.recipients.root', legacyClass: 'mcss-new_email_div-cssm', description: 'Recipients field root.' },
  { contract: 'editor.recipients.list', legacyClass: 'mcss-new_to_msg_list-cssm', description: 'Recipients selected-address list.' },
  { contract: 'editor.recipients.button', legacyId: 'mcss-to_address_button-cssm', description: 'Recipients helper button.' },
  { contract: 'editor.recipients.span', legacyId: 'mcss-to_address_span-cssm', description: 'Recipients helper span.' },
  { contract: 'editor.recipients.checkButton', legacyId: 'mcss-check_to_msg_btn-cssm', description: 'Recipients check button.' },
  { contract: 'editor.recipients.emailCheck', legacyId: 'mcss-to_email_check-cssm', description: 'Recipients email-check marker.' },
  { contract: 'editor.recipients.msgCheck', legacyId: 'mcss-to_msg_check-cssm', description: 'Recipients msg-check marker.' },
  { contract: 'editor.body', legacyId: 'mcss-tr_textarea-cssm', description: 'Editor body/text region.' },
  { contract: 'editor.body.textarea', legacyId: 'mcss-msg_textarea-cssm', description: 'Plain textarea rich-text bridge target.' },
  { contract: 'editor.settings', legacyId: 'mcss-tr_settings-cssm', description: 'Editor settings wrapper.' },
  { contract: 'editor.settings.main', legacyId: 'mcss-main_fieldset-cssm', description: 'Main settings fieldset.' },
  { contract: 'editor.settings.advanced', legacyId: 'mcss-advanced_fieldset-cssm', description: 'Advanced settings fieldset.' },
  { contract: 'editor.settings.email', legacyId: 'mcss-email_fieldset-cssm', description: 'Email settings fieldset.' },
  { contract: 'editor.settings.counts', description: 'Count settings fieldset split from the legacy email/count group.' },
  { contract: 'editor.settings.more', legacyId: 'mcss-more_section-cssm', description: 'Editor more settings body.' },
  { contract: 'editor.settings.protect', legacyId: 'mcss-fieldset_protect-cssm', description: 'Protection settings form.' },
  { contract: 'editor.settings.avatar', legacyId: 'mcss-avatar_fieldset-cssm', description: 'Avatar settings fieldset.' },
  { contract: 'editor.settings.avatarForm', legacyId: 'mcss-avatar_form-cssm', description: 'Avatar upload form.' },
  { contract: 'editor.settings.pageColor', legacyId: 'mcss-is_page_options_color-cssm', description: 'Page color input.' },
  { contract: 'editor.settings.pageOptions', legacyId: 'mcss-page_options_fieldset-cssm', description: 'Page options fieldset.' },
  { contract: 'editor.nameKey.defaultAuto', legacyId: 'mcss-default_auto_name_key-cssm', description: 'Default smart name-key choice.' },
  { contract: 'editor.nameKey.subKey', legacyId: 'mcss-sub_key-cssm', description: 'Smart name-key sub-key shortcut.' },
  { contract: 'editor.nameKey.textarea', legacyId: 'mcss-nk21-cssm', description: 'Smart name-key textarea.' },
  { contract: 'editor.nameKey.mirror', legacyId: 'mcss-nk22-cssm', description: 'Smart name-key hidden mirror.' },
  { contract: 'editor.nameKey.check', legacyId: 'mcss-check_name_key-cssm', description: 'Smart name-key check button.' },
  { contract: 'editor.nameKey.emailInfo', legacyId: 'mcss-msg_email_info-cssm', description: 'Smart name-key helper text.' },
  { contract: 'editor.nameKey.showChangeCode', legacyId: 'mcss-show_change_code_key-cssm', description: 'Open code-key editor link.' },
  { contract: 'editor.nameKey.changeCode', legacyId: 'mcss-change_code_key-cssm', description: 'Code-key editor block.' },
  { contract: 'editor.nameKey.checkCode', legacyId: 'mcss-check_code_key-cssm', description: 'Code-key check button.' },
  { contract: 'editor.nameKey.closeChangeCode', legacyId: 'mcss-close_change_code_key-cssm', description: 'Close code-key editor button.' },
  { contract: 'editor.nameKey.codeKeyInfo', legacyId: 'mcss-code_key_info-cssm', description: 'Code-key status text.' },
  { contract: 'editor.time.start', legacyId: 'mcss-timestart-cssm', description: 'Start time helper span.' },
  { contract: 'editor.time.stop', legacyId: 'mcss-timestop-cssm', description: 'Stop time helper span.' },
  { contract: 'editor.actions', legacyClass: 'mcss-newmsg_submit-cssm', description: 'Editor action bar.' },
  { contract: 'editor.actions.moreSectionButton', legacyId: 'mcss-more_section_button-cssm', description: 'More-settings action label.' },
  { contract: 'editor.action.save', legacyId: 'mcss-save_btn-cssm', description: 'Save button.' },
  { contract: 'editor.action.draft', legacyId: 'mcss-draft_btn-cssm', description: 'Draft button.' },
  { contract: 'editor.action.attachForm', legacyId: 'mcss-attaches_form-cssm', description: 'Attachment upload form.' },
  // 'editor.action.moreSettings' duplicated mcss-more_section_button-cssm with
  // the rendered 'editor.actions.moreSectionButton' above — removed (see the
  // one-alias-per-legacyId rule near editor.extName).
  { contract: 'editor.action.delete', legacyId: 'mcss-del_btn-cssm', description: 'Hidden delete action.' },
  { contract: 'editor.action.clear', legacyId: 'mcss-clear_btn-cssm', description: 'Hidden clear action.' },
  { contract: 'editor.action.saveAndGo', legacyId: 'mcss-save_and_go_btn-cssm', description: 'Hidden save-and-go action.' },
  { contract: 'editor.action.restore', legacyId: 'mcss-restore_btn-cssm', description: 'Hidden restore action.' },
  { contract: 'editor.attachments.gallery', legacyClasses: ['mcss-attaches_gallery-cssm', 'mcss-att_glr-cssm'], description: 'Editor attachments gallery.' },
  { contract: 'editor.body.richFormatButton', legacyId: 'mcss-rich_format_butt-cssm', description: 'Rich format toggle button.' },
  { contract: 'editor.body.isDirty', legacyId: 'mcss-is_Dirty-cssm', description: 'Dirty state indicator.' },
  { contract: 'editor.body.richExt', legacyId: 'mcss-rich_ext-cssm', description: 'Rich editor toolbar.' },
  { contract: 'editor.body.dskEls', legacyId: 'mcss-dsk_els-cssm', description: 'Editor dsk elements toolbar.' },
  { contract: 'editor.quickReply.root', legacyId: 'mcss-msgeditform-cssm', description: 'Quick-reply popup root.' },
  { contract: 'editor.quickReply.form', legacyId: 'mcss-quick_reply_form-cssm', description: 'Quick-reply form container.' },
  { contract: 'editor.quickReply.input', legacyId: 'mcss-quickreplyinput-cssm', description: 'Quick-reply textarea.' },
  { contract: 'editor.quickReply.sendEmail', legacyId: 'mcss-qr_is_send_email-cssm', description: 'Quick-reply send-email checkbox.' },
  { contract: 'editor.quickReply.link', legacyId: 'mcss-qr_is_link-cssm', description: 'Quick-reply link-only checkbox.' },
  { contract: 'editor.pin.root', legacyId: 'mcss-msgenterpinform-cssm', description: 'Pin entry popup.' },
  { contract: 'editor.pin.input', legacyId: 'mcss-pininput-cssm', description: 'Pin input.' },
  { contract: 'editor.loading', legacyId: 'mcss-img_loading-cssm', description: 'Loading overlay.' },

  { contract: 'sidebar.root', legacyId: 'mcss-leftblock-cssm', description: 'Left menu root.' },
  { contract: 'sidebar.wait', legacyId: 'mcss-wait_el-cssm', description: 'Legacy wait popup.' },
  { contract: 'sidebar.editGroup.button', legacyId: 'mcss-edit_group_button-cssm', description: 'Edit-group toggle.' },
  { contract: 'sidebar.editGroup.body', legacyId: 'mcss-edit_group-cssm', description: 'Edit-group body.' },
  { contract: 'sidebar.moreSettings', legacyId: 'mcss-more_section_button_menu-cssm', description: 'Sidebar more-settings button.' },

  { contract: 'subs.toolbar', legacyId: 'mcss-mainmsg_subs_tools-cssm', legacyClass: 'mcss-subs_tools-cssm', description: 'Main subs toolbar.' },
  { contract: 'subs.toolbar.hide', legacyClasses: ['mcss-msg_subs_hide-cssm', 'mcss-no_select-cssm'], description: 'Main subs fold/hide toolbar button.' },
  { contract: 'subs.toolbar.groupsInfo', legacyId: 'mcss-mainmsg_groups_info-cssm', legacyClass: 'mcss-msg_groups-cssm', description: 'Selected-group primary toolbar action.' },
  { contract: 'subs.toolbar.groupsInfo2', legacyId: 'mcss-mainmsg_groups_info2-cssm', legacyClass: 'mcss-msg_groups-cssm', description: 'Selected-group secondary toolbar action.' },
  { contract: 'subs.toolbar.message', legacyId: 'mcss-mainmsg_groups_message-cssm', legacyClass: 'mcss-inline_info_message-cssm', description: 'Selected-group status message.' },
  { contract: 'subs.panelTools', legacyClass: 'mcss-subs_tls-cssm', description: 'Subs panel local tools row.' },
  { contract: 'subs.menuToggle.answers', legacyClass: 'mcss-sub_answ_div_hide-cssm', description: 'Menu panel answers toggle.' },
  { contract: 'subs.menuToggle.submsges', legacyClass: 'mcss-sub_answ_div_hide_2-cssm', description: 'Menu panel messages toggle.' },
  { contract: 'subs.menuToggle.count', legacyClass: 'mcss-subs_btn_2-cssm', description: 'Menu panel count marker.' },
  { contract: 'subs.togglePhoto', legacyClass: 'mcss-toggle_foto-cssm', description: 'Menu panel photo toggle.' },
  { contract: 'subs.menuMode.panel', legacyClass: 'mcss-subs_style_div-cssm', description: 'Menu-mode subs panel body.' },
  { contract: 'subs.menuMode.answersList', legacyClasses: ['mcss-list_answers_ul-cssm', 'mcss-mainmsg_ul-cssm', 'mcss-ul_comments-cssm'], description: 'Menu-mode answers list.' },
  { contract: 'subs.menuMode.submsgesList', legacyClasses: ['mcss-list_submsges_ul-cssm', 'mcss-mainmsg_ul-cssm', 'mcss-ul_compact-cssm'], description: 'Menu-mode messages list.' },
  { contract: 'subs.favs.answersFront', legacyId: 'mcss-msg_favs_0-cssm', description: 'Bookmarks answers panel.' },
  { contract: 'subs.favs.submsgesFront', legacyId: 'mcss-msg_favs_1-cssm', description: 'Bookmarks messages panel.' },
  { contract: 'subs.trash.answersFront', legacyId: 'mcss-msg_trash_answers-cssm', description: 'Basket answers panel.' },
  { contract: 'subs.trash.submsgesFront', legacyId: 'mcss-msg_trash_submsges-cssm', description: 'Basket messages panel.' },
  { contract: 'subs.drafts.answersFront', legacyId: 'mcss-msg_drafts_answers-cssm', description: 'Drafts answers panel.' },
  { contract: 'subs.drafts.submsgesFront', legacyId: 'mcss-msg_drafts_submsges-cssm', description: 'Drafts messages panel.' },
  { contract: 'subs.answers.front', legacyId: 'mcss-msg_answers_front-cssm', legacyClasses: ['mcss-msg_answers_div-cssm', 'mcss-subs_style_div-cssm'], description: 'Root answers panel.' },
  { contract: 'subs.answers.rootList', legacyId: 'mcss-answers_ul-cssm', legacyClasses: ['mcss-list_answers_ul-cssm', 'mcss-mainmsg_ul-cssm', 'mcss-ul_comments-cssm'], description: 'Root answers list.' },
  { contract: 'subs.submsges.front', legacyId: 'mcss-msg_submsges_front-cssm', legacyClasses: ['mcss-msg_submsges_div-cssm', 'mcss-subs_style_div-cssm'], description: 'Root messages panel.' },
  { contract: 'subs.submsges.rootList', legacyId: 'mcss-submsges_ul-cssm', legacyClasses: ['mcss-list_submsges_ul-cssm', 'mcss-mainmsg_ul-cssm', 'mcss-ul_compact-cssm'], description: 'Root messages list.' },
  { contract: 'subs.paging.answers', legacyClasses: ['mcss-paging_el-cssm', 'mcss-no_select-cssm'], description: 'Answers paging bar.' },
  { contract: 'subs.paging.submsges', legacyClasses: ['mcss-paging_el-cssm', 'mcss-no_select-cssm'], description: 'Messages paging bar.' },
  { contract: 'subs.checked.answers', legacyId: 'mcss-checkeds_info_0-cssm', description: 'Answers selected-toolbar region.' },
  { contract: 'subs.checked.submsges', legacyId: 'mcss-checkeds_info_1-cssm', description: 'Messages selected-toolbar region.' },
  { contract: 'legacyData.msges', legacyId: 'mcss-msges_data-cssm', description: 'Hidden legacy msges data payload.' },
  { contract: 'legacyData.msgesJson', legacyId: 'mcss-msges_data_json-cssm', description: 'Hidden legacy msges JSON data payload.' },
  { contract: 'legacyData.init', legacyId: 'mcss-init_data-cssm', description: 'Hidden legacy init data payload.' },
] as const;

const LEGACY_COMPOUND_SELECTOR_ALIASES: readonly LegacyCompoundSelectorAlias[] = [
  {
    parent: 'subs.answers.front',
    parentLegacyTokens: ['mcss-msg_answers_front-cssm', 'mcss-msg_answers_div-cssm'],
    childLegacyClass: 'mcss-list_answers_ul-cssm',
    child: 'subs.answers.rootList',
    description: 'Root answers panel -> answers list.',
  },
  {
    parent: 'subs.submsges.front',
    parentLegacyTokens: ['mcss-msg_submsges_front-cssm', 'mcss-msg_submsges_div-cssm'],
    childLegacyClass: 'mcss-list_submsges_ul-cssm',
    child: 'subs.submsges.rootList',
    description: 'Root messages panel -> messages list.',
  },
  {
    parent: 'subs.favs.answersFront',
    parentLegacyTokens: ['mcss-msg_favs_0-cssm'],
    childLegacyClass: 'mcss-list_answers_ul-cssm',
    child: 'subs.menuMode.answersList',
    description: 'Bookmarks answers panel -> menu answers list.',
  },
  {
    parent: 'subs.favs.submsgesFront',
    parentLegacyTokens: ['mcss-msg_favs_1-cssm'],
    childLegacyClass: 'mcss-list_submsges_ul-cssm',
    child: 'subs.menuMode.submsgesList',
    description: 'Bookmarks messages panel -> menu messages list.',
  },
  {
    parent: 'subs.trash.answersFront',
    parentLegacyTokens: ['mcss-msg_trash_answers-cssm'],
    childLegacyClass: 'mcss-list_answers_ul-cssm',
    child: 'subs.menuMode.answersList',
    description: 'Basket answers panel -> menu answers list.',
  },
  {
    parent: 'subs.trash.submsgesFront',
    parentLegacyTokens: ['mcss-msg_trash_submsges-cssm'],
    childLegacyClass: 'mcss-list_submsges_ul-cssm',
    child: 'subs.menuMode.submsgesList',
    description: 'Basket messages panel -> menu messages list.',
  },
  {
    parent: 'subs.drafts.answersFront',
    parentLegacyTokens: ['mcss-msg_drafts_answers-cssm'],
    childLegacyClass: 'mcss-list_answers_ul-cssm',
    child: 'subs.menuMode.answersList',
    description: 'Drafts answers panel -> menu answers list.',
  },
  {
    parent: 'subs.drafts.submsgesFront',
    parentLegacyTokens: ['mcss-msg_drafts_submsges-cssm'],
    childLegacyClass: 'mcss-list_submsges_ul-cssm',
    child: 'subs.menuMode.submsgesList',
    description: 'Drafts messages panel -> menu messages list.',
  },
] as const;

const byContract = new Map<LegacyContractName, LegacySelectorAlias>(
  LEGACY_SELECTOR_ALIASES.map(alias => [alias.contract, alias]),
);

const byLegacyId = new Map<string, LegacySelectorAlias>();
const byLegacyClass = new Map<string, LegacySelectorAlias>();
const legacyClassCounts = new Map<string, number>();
for (const alias of LEGACY_SELECTOR_ALIASES) {
  if (alias.legacyClass) legacyClassCounts.set(alias.legacyClass, (legacyClassCounts.get(alias.legacyClass) || 0) + 1);
}
for (const alias of LEGACY_SELECTOR_ALIASES) {
  if (alias.legacyId) {
    // One alias per legacyId, enforced at module load: with duplicates the
    // selector REWRITER resolves to the first entry while this map keeps the
    // last, and legacy "#mcss-*" lookups silently target the wrong contract
    // (that is how toggle_code_key went dead). legacyClass stays one-to-many
    // (e.g. mcss-msg_groups-cssm) because legacy uses class sets.
    const existing = byLegacyId.get(alias.legacyId);
    if (existing && existing.contract !== alias.contract) {
      throw new Error(`[SelectorContracts] duplicate legacyId "${alias.legacyId}": ${existing.contract} vs ${alias.contract}`);
    }
    byLegacyId.set(alias.legacyId, alias);
  }
  if (alias.legacyClass && legacyClassCounts.get(alias.legacyClass) === 1) byLegacyClass.set(alias.legacyClass, alias);
}

function escapeAttr(value: string): string {
  return value.replace(/\\/g, '\\\\').replace(/"/g, '\\"');
}

function escapeRegExp(value: string): string {
  return value.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
}

export function legacyContract(contract: LegacyContractName): LegacySelectorAlias {
  const alias = byContract.get(contract);
  if (!alias) throw new Error(`Unknown legacy contract: ${contract}`);
  return alias;
}

export function legacyId(contract: LegacyContractName): string | undefined {
  return legacyContract(contract).legacyId;
}

export function legacyClass(contract: LegacyContractName): string | undefined {
  return legacyContract(contract).legacyClass;
}

export function legacyClasses(contract: LegacyContractName): string[] {
  const alias = legacyContract(contract);
  return [
    alias.legacyClass,
    ...(alias.legacyClasses || []),
  ].filter(Boolean) as string[];
}

export function classNames(...values: Array<string | false | null | undefined>): string {
  return values.filter(Boolean).join(' ');
}

export function legacyCssClasses(...tokens: LegacyCssTokenName[]): string {
  void tokens;
  return '';
}

export function legacyCssClass(token: LegacyCssTokenName): string {
  return LEGACY_CSS_TOKENS[token];
}

export type LegacySubElementName =
  | 'row'
  | 'checkIcon'
  | 'favorite'
  | 'quickReply'
  | 'titleLink'
  | 'text'
  | 'time'
  | 'info'
  | 'childrenAnswers'
  | 'childrenSubmsges';

export function legacySubElementId(kind: LegacySubElementName, elId: string | number, typeId?: number): string {
  switch (kind) {
    case 'row':
      return `mcss-li_id-cssm_${elId}`;
    case 'checkIcon':
      return `mcss-msg_icon-cssm_${elId}`;
    case 'favorite':
      return `mcss-fav-cssm_${elId}`;
    case 'quickReply':
      return `mcss-qr-cssm_${elId}`;
    case 'titleLink':
      return `mcss-sub_link-cssm_${elId}`;
    case 'text':
      return `mcss-list_txt-cssm_${elId}`;
    case 'time':
      return `time_${elId}`;
    case 'info':
      return `mcss-sub_info-cssm_${typeId}_${elId}`;
    case 'childrenAnswers':
      return `mcss-ul_id-cssm_${elId}`;
    case 'childrenSubmsges':
      return `mcss-ul_id-cssm_${elId}_submsges`;
  }
}

export function legacySubElementAttrs(
  kind: LegacySubElementName,
  elId: string | number,
  typeId?: number,
): { 'data-md-el-id': string; 'data-md-sub-part': string; 'data-md-type-id'?: string } {
  return {
    'data-md-el-id': String(elId),
    'data-md-sub-part': kind,
    ...(kind === 'info' && typeId != null ? { 'data-md-type-id': String(typeId) } : {}),
  };
}

export function contractSelector(contract: LegacyContractName): string {
  return `[data-md-contract="${escapeAttr(contract)}"]`;
}

export type LegacyContractRef = (node: HTMLElement | null) => void;

const legacyContractRefs = new Map<LegacyContractName, LegacyContractRef>();

export function legacyContractRef(contract: LegacyContractName): LegacyContractRef {
  const cached = legacyContractRefs.get(contract);
  if (cached) return cached;
  const ref = (node: HTMLElement | null) => {
    const store = getMsgDeskRuntime().getGlobal<any>('treeStore');
    if (!store?.mutate) return;
    if (node) store.mutate.registerContract?.(contract, node);
    else store.mutate.unregisterContract?.(contract);
  };
  legacyContractRefs.set(contract, ref);
  return ref;
}

export function legacyContractAttrs(contract: LegacyContractName): { 'data-md-contract': LegacyContractName; ref: LegacyContractRef } {
  return {
    'data-md-contract': contract,
    ref: legacyContractRef(contract),
  };
}

export function legacyContractDataAttrs(contract: LegacyContractName): { 'data-md-contract': LegacyContractName; ref: LegacyContractRef } {
  return {
    'data-md-contract': contract,
    ref: legacyContractRef(contract),
  };
}

export function legacyHookAttrs(
  contract: LegacyContractName,
  templateClassName?: string,
): { className: string; 'data-md-contract': LegacyContractName; ref: LegacyContractRef } {
  return {
    ...legacyContractAttrs(contract),
    className: classNames(templateClassName),
  };
}

export function legacySelectorContract(selector: string): LegacyContractName | null {
  const raw = String(selector || '').trim();
  const id = raw.match(/^#([A-Za-z0-9_:-]+)$/)?.[1];
  if (id && byLegacyId.has(id)) return byLegacyId.get(id)!.contract;
  const className = raw.match(/^\.([A-Za-z0-9_-]+)$/)?.[1];
  if (className && byLegacyClass.has(className)) return byLegacyClass.get(className)!.contract;
  return null;
}

export function rewriteLegacySelectorToContract(selector: string): string {
  let rewritten = String(selector || '');
  for (const alias of LEGACY_COMPOUND_SELECTOR_ALIASES) {
    const parentContractSel = contractSelector(alias.parent);
    const hasParent = alias.parentLegacyTokens.some(token => rewritten.includes(token)) ||
      rewritten.includes(parentContractSel);
    if (!hasParent) continue;
    rewritten = rewritten.replace(
      new RegExp(`\\.${escapeRegExp(alias.childLegacyClass)}(?![A-Za-z0-9_-])`, 'g'),
      contractSelector(alias.child),
    );
  }
  for (const alias of LEGACY_SELECTOR_ALIASES) {
    const contractSel = contractSelector(alias.contract);
    if (alias.legacyId) {
      rewritten = rewritten.replace(
        new RegExp(`#${escapeRegExp(alias.legacyId)}(?![A-Za-z0-9_-])`, 'g'),
        contractSel,
      );
    }
    if (alias.legacyClass) {
      rewritten = rewritten.replace(
        new RegExp(`\\.${escapeRegExp(alias.legacyClass)}(?![A-Za-z0-9_-])`, 'g'),
        contractSel,
      );
    }
  }
  return rewritten;
}

export function installLegacySelectorAliasesGlobal() {
  getMsgDeskRuntime().setGlobal('__MSG_LEGACY_SELECTOR_ALIASES__', {
    entries: LEGACY_SELECTOR_ALIASES,
    compoundEntries: LEGACY_COMPOUND_SELECTOR_ALIASES,
    stateClasses: LEGACY_STATE_CLASSES,
    readPredicates: LEGACY_READ_PREDICATES,
    contractSelector,
    legacySelectorContract,
    rewriteSelector: rewriteLegacySelectorToContract,
  });
}
